export default __webpack_public_path__ + "static/media/image.6b49c01a.png";